import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { fetchAsyncSearchClientProjectData } from 'redux/clientProjectSlice';
import { fetchAsyncSearchDTData } from 'redux/directTaxSlice';
import { fetchAsyncSearchEmbrillProfileData } from 'redux/embrillProfileSlice';
import { fetchAsyncSearchTdsRecords } from 'redux/invoicePaymentRecordSlice';
import { fetchAsyncSearchPaymentRecords } from 'redux/invoicePaymentRecordSlice';
import { fetchAsyncSearchGstRecords } from 'redux/invoicePaymentRecordSlice';
import { fetchAsyncSearchExpenseData } from 'redux/OrganizationExpenseSlice';
import { fetchAsyncSearchItemsData } from 'redux/purchaseItemSlice';
import { fetchAsyncSearchInvoiceData } from 'redux/salesInvoice';
import { fetchAsyncSearchSalesItemsData } from 'redux/salesItemSlice';
import { fetchAsyncSearchGstData } from 'redux/slices/gstSlice';
import { setCurrency } from 'redux/slices/searchTextSlice';
import { setFilteredData } from 'redux/slices/searchTextSlice';

import { fetchAsyncSearchTdsData } from 'redux/tdsSlice';
import { fetchAsyncSearchUser } from 'redux/userSlice';
import { fetchAsyncSearchVendorData } from 'redux/vendorSlice';


const SEARCH_ACTIONS = {
  '/tds': ({ value, startDate, endDate }) => 
    fetchAsyncSearchTdsData({ value, startDate, endDate }),
  
  '/direct-tax': ({ value, startDate, endDate }) =>
    fetchAsyncSearchDTData({ value, startDate, endDate }),
  
  '/gst': ({ value, startDate, endDate }) =>
    fetchAsyncSearchGstData({ value, startDate, endDate }),
  
  '/vendor': ({ value, startDate, endDate }) =>
    fetchAsyncSearchVendorData({ value, startDate, endDate }),
  
  '/users': ({ value }) =>
    fetchAsyncSearchUser({ value }),
  
  '/client-project': ({ value, startDate, endDate }) =>
    fetchAsyncSearchClientProjectData({ value, startDate, endDate }),
  
  '/organization-bank': ({ value, startDate, endDate }) =>
    fetchAsyncSearchEmbrillProfileData({ value, startDate, endDate }),
  
  '/purchase-items': ({ value }) =>
    fetchAsyncSearchItemsData({ value }),
  
  '/sales-items': ({ value, currency }) => [
    setCurrency({ currencyCode:currency}),
    fetchAsyncSearchSalesItemsData({ value, currency }),
  ],
  
  '/invoice-gst': ({ value, startDate, endDate }) =>
    fetchAsyncSearchGstRecords({ value, startDate, endDate }),
  
  '/invoice-tds': ({ value, startDate, endDate }) =>
    fetchAsyncSearchTdsRecords({ value, startDate, endDate }),
  
  '/payment-received': ({ value, startDate, endDate }) =>
    fetchAsyncSearchPaymentRecords({ value, startDate, endDate })
};

const useSearch = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { filteredListType } = useSelector(state => state.filteredList);
  const { currencyCode } = useSelector(state => state.currency);
  const orgModule = useSelector((state) => state.moduleType);

  const performSearch = useCallback((value, startDate, endDate,listType,currCode) => {
    const actionConfig = SEARCH_ACTIONS[location.pathname];
    const params = { value, startDate, endDate, currency: currCode || currencyCode };

    if (actionConfig) {
      const actions = actionConfig(params);
      if (Array.isArray(actions)) {
        actions.forEach(dispatch);
      } else {
        dispatch(actions);
      }
    } else {
      const pathSegments = location.pathname.split('/');
      const moduleId = pathSegments[pathSegments.length - 1];
      const isOrgModule = orgModule.some(module => module._id === moduleId);

      if (isOrgModule) {
        if(listType){
          dispatch(setFilteredData({ filteredListType:listType}));
        }

        dispatch(fetchAsyncSearchExpenseData({ 
          moduleId, 
          value, 
          startDate, 
          endDate, 
          listType: listType || filteredListType 
        }));
      }
      else{
          if(currCode){
            dispatch(setCurrency({ currencyCode:currCode}));
          }
          dispatch(fetchAsyncSearchInvoiceData({ 
            moduleId, 
            value, 
            startDate, 
            endDate, 
            currency: currCode || currencyCode 
          }));
      }
    }
  }, [dispatch, location.pathname, filteredListType, currencyCode,orgModule]);

  return { performSearch };
};

export default useSearch;
